export const calculateZoomObjFormData = (objFormData) => {
  try {
    return parseInt(
      objFormData.find((item) => item.attrName === 'zoom').defaultValue
    );
  } catch (e) {}
};
